<template>
	<component :is="baseComponent" :to="link.path ? link.path : '/'" :class="{ active: isActive }" tag="li">

		<div v-if="isMenu" class="nav-link sidebar-menu-item sidebar-menu-category"
		     data-toggle="collapse" :aria-expanded="collapsed">
			<span class="sidebar-mini">{{ linkPrefix }}</span>
			<span class="sidebar-normal">{{ link.name }}</span>
		</div>

		<collapse-transition>
			<div v-if="$slots.default || this.isMenu" v-show="true">
				<ul class="nav">
					<slot></slot>
				</ul>
			</div>
		</collapse-transition>

		<slot name="title"
			v-if="children.length === 0 && !$slots.default && link.path">
			<div class="nav-link sidebar-item" :class="{ active: isSubLinkActive(link) }" @mousedown="goToRoute($event, link.route)">
				<template>
					<font-awesome-icon class="md-icon" :icon="['fa', link.icon]" />
					<span class="sidebar-normal">{{ link.name }}</span>
				</template>
			</div>
		</slot>
	</component>
</template>
<script>
import routerMixin from "../../mixins/router-mixin";

export default {
	name: "SidebarItem",
    mixins: [routerMixin],
	props: {
		menu: {
			type: Boolean,
			default: false
		},
		opened: {
			type: Boolean,
			default: false
		},
		link: {
			type: Object,
			default: () => {
				return {
					name: "",
					icon: "",
					image: "",
					path: "",
					children: []
				};
			}
		}
	},
	provide() {
		return {
			addLink: this.addChild,
			removeLink: this.removeChild
		};
	},
	inject: {
		addLink: { default: null },
		removeLink: { default: null },
		autoClose: {
			default: true
		}
	},
	data() {
		return {
			children: [],
			collapsed: !this.opened
		};
	},
	computed: {
		baseComponent() {
			return this.isMenu || this.link.isRoute ? "li" : "router-link";
		},
		linkPrefix() {
			if (this.link.name) {
				let words = this.link.name.split(" ");
				return words.map(word => word.substring(0, 1)).join("");
			}
			return false;
		},
		isMenu() {
			return this.children.length > 0 || this.menu === true;
		},
		isActive() {
			if (this.$route && this.$route.path) {
				let matchingRoute = this.children.find(c =>
					this.$route.path.startsWith(c.link.path)
				)
				if (matchingRoute !== undefined) {
					return true;
				}
			}
			return false;
		}
	},
	methods: {
		addChild(item) {
			const index = this.$slots.default.indexOf(item.$vnode);
			this.children.splice(index, 0, item);
		},
		removeChild(item) {
			const tabs = this.children;
			const index = tabs.indexOf(item);
			tabs.splice(index, 1);
		},
		elementType(link, isParent = true) {
			if (link.isRoute === false) {
				return isParent ? "li" : "a";
			} else {
				return "router-link";
			}
		},
		isSubLinkActive(link) {
			return this.$route && this.$route.path && this.$route.path.includes(link.path)
		},
		linkClick() {
			if (!this.addLink) {
				this.$sidebar.collapseAllMenus();
			}

			if (
				this.autoClose &&
				this.$sidebar &&
				this.$sidebar.showSidebar === true
			) {
				this.$sidebar.displaySidebar(false);
			}
		},
		collapseMenu() {
			if (this.collapsed) {
				this.$sidebar.addSidebarLink(this);
				this.$sidebar.collapseAllMenus();
			}

			this.collapsed = !this.collapsed;
		},
		collapseSubMenu(link) {
			link.collapsed = !link.collapsed;
		}
	},
	mounted() {
		if (this.addLink) {
			this.addLink(this);
		}
		if (this.link.collapsed !== undefined) {
			this.collapsed = this.link.collapsed;
		}
		if (this.isActive && this.isMenu) {
			this.collapsed = false;
		}
	},
	destroyed() {
		this.$sidebar.removeSidebarLink(this);
		if (this.$el && this.$el.parentNode) {
			this.$el.parentNode.removeChild(this.$el);
		}
		if (this.removeLink) {
			this.removeLink(this);
		}
	}
};
</script>
<style lang="scss">
.sidebar-mini {
    .sidebar .sidebar-wrapper > .nav li {
        span.sidebar-normal {
            -webkit-transform: translate3d(-25px, 0, 0);
            transform: translate3d(-25px, 0, 0);
            transition: transform 300ms linear, opacity 300ms linear, -webkit-transform 300ms linear;
            white-space: nowrap;
            display: block;
            margin: 0;
            position: relative;
            opacity: 0;
            height: 24px;
            line-height: 25px;
        }
    }
    .sidebar:hover .sidebar-wrapper > .nav li {
        span.sidebar-normal {
            -webkit-transform: translate3d(0px, 0, 0);
            transform: translate3d(0px, 0, 0);
            opacity: 1;
        }
    }
    .sidebar-wrapper {
        .nav-link.sidebar-item {
            display: block;
        }
        .sidebar-menu-item {
            display: block;
            .sidebar-normal {
                height: 24px;
                line-height: 24px;
            }
        }
    }
}

.sidebar-wrapper {
    .nav {
        margin: 10px 0 0 !important;
        li:first-child > .sidebar-item {
            margin: 0 15px;
        }
        li:hover > .sidebar-item {
            background: rgba(200, 200, 200, 0.2);
        }
        li.active > .sidebar-item {
            background-color: #dd4b39;
            box-shadow: 0 12px 20px -10px rgba(221, 75, 57, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(221, 75, 57, 0.2);
        }
    }
    .sidebar-menu-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        min-height: 40px;
    }
    .nav-link.sidebar-item {
        display: flex;
        align-items: center;
        text-decoration: none;
        margin: 10px 15px 0;
        border-radius: 3px;
        color: #FFFFFF !important;
        white-space: nowrap;
        padding: 8px 10px;
        font-size: 13px;
        cursor: pointer;
        width: auto;
        transition: all 150ms ease-in;
        min-height: 40px;
    }
}

.sidebar-menu-category {
    cursor: default !important;
    padding: 8px 10px;
    margin: 10px 15px 0;
    border-radius: 3px;
    background-color: #575757 !important;
    span {
        font-size: 15px !important;
        font-weight: 600 !important;
    }
}

.nav-link {
    .sidebar-mini, svg {
        min-width: 16px !important;
        font-size: 16px !important;
        float: left;
        margin: 0;
        margin-right: 15px !important;
        width: 30px !important;
        height: 24px;
        text-align: center;
        color: #FFFFFF;
    }
    svg {
        line-height: 30px;
        padding: .25rem;
    }
    .sidebar-normal {
        font-weight: 400;
    }
}
</style>
